import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pg_icon = _resolveComponent("pg-icon")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createBlock(_component_van_tabbar, {
    modelValue: _ctx.activeTab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
    fixed: false,
    "active-color": "#178CA6",
    "inactive-color": "#868A9A"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAuthed, (item, index) => {
        return (_openBlock(), _createBlock(_component_van_tabbar_item, {
          key: index,
          replace: "",
          to: item.link
        }, {
          icon: _withCtx((scope) => [
            (item.iconImg)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["pe-tabbar-icon pe-tabbar-icon-mask", { 'pe-tabbar-icon-img--active': scope.active }]),
                  style: _normalizeStyle(_ctx.getIconMaskStyle(scope.active, item)),
                  "aria-hidden": "true"
                }, null, 6))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (scope.active)
                    ? (_openBlock(), _createBlock(_component_pg_icon, {
                        key: 0,
                        class: "pe-tabbar-icon",
                        name: item.iconActive,
                        style: {"color":"#178CA6"}
                      }, null, 8, ["name"]))
                    : (_openBlock(), _createBlock(_component_pg_icon, {
                        key: 1,
                        class: "pe-tabbar-icon",
                        name: item.icon
                      }, null, 8, ["name"]))
                ], 64))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}